import { Notice } from "../ui/Notice";
import { Tag } from "../ui/Tag";
import { useT, type MsgKey } from "../../lib/i18n";
import { REFRESH_MODES, REFRESH_MODE_TONE, type RefreshMode } from "../../lib/refresh-mode";

const LABEL: Record<RefreshMode, MsgKey> = { normal: "ver.refresh.normal", immediate: "ver.refresh.immediate", force: "ver.refresh.force" };
const DESC: Record<RefreshMode, MsgKey> = { normal: "ver.refresh.normalDesc", immediate: "ver.refresh.immediateDesc", force: "ver.refresh.forceDesc" };
export const refreshModeLabel = (m: RefreshMode): MsgKey => LABEL[m];

/**
 * 生效方式（设计稿 panels.jsx 的 RefreshModePicker）：发布确认与「设为生效」共用。
 * 三行单选卡片，每行名称 + 后果；「强制刷新」非超管置灰并说明原因（服务端同样只认超管）。
 */
export function RefreshModePicker({ value, onChange, isSuper }: {
  value: RefreshMode; onChange: (m: RefreshMode) => void; isSuper: boolean;
}) {
  const t = useT();
  return (
    <div>
      <div className="mb-2 text-sm font-semibold text-ink">{t("ver.refresh.title")}</div>
      <div className="flex flex-col gap-2">
        {REFRESH_MODES.map((m) => {
          const locked = m === "force" && !isSuper;
          const on = value === m;
          return (
            <label key={m}
              className={`flex items-start gap-2 rounded-base border px-3 py-2 ${locked ? "cursor-not-allowed bg-fill-light" : "cursor-pointer"}`
                + ` ${on ? "border-primary bg-primary-50" : "border-line-lighter"}`}>
              <input type="radio" name="refresh-mode" className="mt-1" disabled={locked} checked={on} onChange={() => onChange(m)} />
              <div className="leading-relaxed">
                <div className={`text-sm font-semibold ${locked ? "text-ink-placeholder" : "text-ink"}`}>
                  {t(LABEL[m])}
                  {m === "normal" && <span className="font-normal text-ink-placeholder">{t("ver.refresh.default")}</span>}
                </div>
                <div className={`text-xs ${locked ? "text-ink-placeholder" : "text-ink-secondary"}`}>
                  {locked ? t("ver.refresh.forceLocked") : t(DESC[m])}
                </div>
              </div>
            </label>
          );
        })}
      </div>
      <div className="mt-1.5 text-xs text-ink-placeholder">{t("ver.refresh.rollbackNote")}</div>
      {value === "force" && <div className="mt-3"><Notice tone="warning">{t("ver.refresh.forceWarn")}</Notice></div>}
    </div>
  );
}

/** 版本历史里「上次生效方式」那一格 */
export function RefreshModeTag({ mode }: { mode: RefreshMode | null | undefined }) {
  const t = useT();
  if (!mode) return <span className="text-ink-placeholder">—</span>;
  return <Tag tone={REFRESH_MODE_TONE[mode]}>{t(LABEL[mode])}</Tag>;
}
